import { Optional } from 'utility-types'
import TextFilter, { ITextFilterProps } from './TextFilter'
import { KnockOperator } from '../Knock/KnockTypes'

type NumberFilterProps = Optional<ITextFilterProps, 'validate' | 'operators'>

const NumberFilter = (props: NumberFilterProps) => {
  const validate = /^[0-9]+$/
  const operators = [
    KnockOperator.EqualTo,
    KnockOperator.GreaterThan,
    KnockOperator.GreatThanOrEqualTo,
    KnockOperator.LessThan,
    KnockOperator.LessThanOrEqualTo
  ]

  return <TextFilter validate={validate} operators={operators} {...props} />
}

export default NumberFilter
